// Kasa Transferi (kasadan kasaya) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.cashboxTransfer';

export const cashboxTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kasa transferi nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bir kasadaki parayı aynı para birimindeki başka bir kasaya aktarırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve kaynak kasa'),
    body: t(`${G}.regions.body`, 'Transfer formu'),
    footer: t(`${G}.regions.footer`, 'Transferi Tamamla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kaynak kasayı kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutu, paranın çıkacağı Kaynak Kasa adını ve güncel bakiyesini gösterir. Kaynak kasa, pencereyi açtığınız kasadır; burada değiştirilemez.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hedef kasayı seçin'),
      text: t(`${G}.s2.text`, '"Hedef Kasa" listesinde yalnız kaynak kasayla aynı para birimindeki aktif kasalar çıkar; her birinin yanında bakiyesi yazar.'),
      tips: [
        t(`${G}.s2.tip1`, '"Transfer edilebilecek kasa bulunamadı" yazıyorsa aynı para biriminde başka aktif kasa yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Belge numarası, miktar, açıklama'),
      text: t(`${G}.s3.text`, 'Belge Numarası otomatik gelir (KT-…) ve zorunludur; isterseniz değiştirin. Miktarı 1.000,50 biçiminde girin; kaynak kasanın bakiyesini aşamaz ("Maksimum transfer edilebilir" satırına bakın). Açıklama isteğe bağlıdır; boş bırakılırsa "Kaynak → Hedef kasa transferi" yazılır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Geçmiş tarihli işlem yap" işaretlenirse İşlem Tarihi seçilir; transfer tamamen o tarihe kaydedilir ve belge numarası da o tarihe göre yenilenir. İleri tarih seçilemez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Transferi tamamlayın'),
      text: t(`${G}.s4.text`, '"Transferi Tamamla" hedef kasa, miktar ve belge numarası dolunca açılır. Kayıttan sonra tutar kaynak kasadan çıkış, hedef kasaya giriş olarak işlenir; iki kasanın bakiyesi de hemen değişir ve iki hareket de Kasa Hareket Raporunda görünür.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kaynak kasada yeterli bakiye yoksa transfer yapılmaz ve hata mesajı çıkar.'),
      ],
    },
  ],
});
